import React, { useState } from 'react';
import AppFooter from './AppFooter';
import './PolicyPage.css';

const WEB3FORMS_ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_KEY ?? '';

const Contact: React.FC = () => {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!WEB3FORMS_ACCESS_KEY) {
      setFormStatus('error');
      setFormMessage('The contact form is temporarily unavailable. Please email support@gallopai.app directly.');
      return;
    }

    setFormStatus('submitting');
    setFormMessage('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setFormStatus('success');
        setFormMessage('Thank you for contacting us! We will get back to you as soon as possible.');
        form.reset();
      } else {
        setFormStatus('error');
        setFormMessage('There was an error submitting your message. Please try again.');
      }
    } catch (error) {
      setFormStatus('error');
      setFormMessage('There was an error submitting your message. Please try again.');
    }
  };

  return (
    <div className="policy-page">
      <div className="policy-header">
        <img src="/white_wide_logo_noBG.png" alt="GallopAI" className="policy-logo" />
        <h1 className="policy-title">Contact Us</h1>
        <p className="policy-updated">We're here to help. Send us a message and we'll respond as soon as possible.</p>
      </div>
      
      <div className="policy-content">
        <div className="policy-card">
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="hidden"
              name="access_key"
              value={WEB3FORMS_ACCESS_KEY}
            />
            <input type="hidden" name="from_name" value="GallopAI Contact Form" />

            <div className="contact-form-group">
              <label htmlFor="name" className="contact-form-label">
                Name <span className="required">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                className="contact-form-input"
                required
                disabled={formStatus === 'submitting'}
              />
            </div>

            <div className="contact-form-group">
              <label htmlFor="email" className="contact-form-label">
                Email <span className="required">*</span>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="contact-form-input"
                required
                disabled={formStatus === 'submitting'}
              />
            </div>

            <div className="contact-form-group">
              <label htmlFor="subject" className="contact-form-label">
                Subject <span className="required">*</span>
              </label>
              <select
                id="subject"
                name="subject"
                className="contact-form-input contact-form-select"
                required
                disabled={formStatus === 'submitting'}
              >
                <option value="">Select a subject</option>
                <option value="General Inquiry">General Inquiry</option>
                <option value="Refund Request">Refund Request</option>
                <option value="Technical Support">Technical Support</option>
                <option value="Account Issue">Account Issue</option>
                <option value="Privacy/Data Request">Privacy/Data Request</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="contact-form-group">
              <label htmlFor="message" className="contact-form-label">
                Message <span className="required">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                className="contact-form-input contact-form-textarea"
                rows={6}
                required
                disabled={formStatus === 'submitting'}
                placeholder="Please provide details about your inquiry..."
              />
            </div>

            {formStatus === 'success' && (
              <div className="contact-form-message contact-form-success">
                {formMessage}
              </div>
            )}

            {formStatus === 'error' && (
              <div className="contact-form-message contact-form-error">
                {formMessage}
              </div>
            )}

            <button
              type="submit"
              className="contact-form-button"
              disabled={formStatus === 'submitting'}
            >
              {formStatus === 'submitting' ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>

      <AppFooter />
    </div>
  );
};

export default Contact;

